<template>
  <div>
    <el-row :gutter="16" v-loading="loading.cardLoading">
      <el-col :lg="12" :md="24" :sm="24" :xl="12" class="mb-18">
        <reportChart
          :config="teamTarget"
          style="height: 195px"
          :custom="{
            height: '195px',
            slotText: true,
          }"
        >
          <template #left>
            <div class="info-wrap">
              <p class="info-title">{{ $t('merits-board::teamGmv') }}</p>
              <div class="info-number">${{ $dataCheck(formatNumberMix(perforTarget.teamGmv, 2), '-') }}</div>
              <div class="info-next">
                <div class="info-left">
                  <span class="ring"></span>
                  {{ $t('merits-board::teamTarget') }}
                </div>
                <div class="info-right" v-if="perforTarget.teamTarget">
                  ${{ $dataCheck(formatNumberMix(perforTarget.teamTarget, 2), 0) }}
                </div>
                <div class="info-right" v-else>
                  {{ $t('merits-board::暂未设置目标') }}
                  <a @click="$router.push('/operate-config?type=target')">
                    {{ $t('config-manager::operate-config::目标配置') }}
                  </a>
                </div>
              </div>
            </div>
          </template>
        </reportChart>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24" :xl="12" class="mb-18">
        <reportChart :config="personalTarget" style="height: 195px">
          <template #left>
            <div class="info-wrap">
              <p class="info-title">{{ $t('merits-board::gmv') }}</p>
              <div class="info-number">${{ $dataCheck(formatNumberMix(perforTarget.gmv, 2), '-') }}</div>
              <div class="info-next">
                <div class="info-left">
                  <span class="ring"></span>
                  {{ $t('merits-board::target') }}
                </div>
                <div class="info-right" v-if="perforTarget.target">${{ formatNumberMix(perforTarget.target, 2) }}</div>
                <div class="info-right" v-else>
                  {{ $t('merits-board::暂未设置目标') }}
                  <a @click="$router.push('/operate-config?type=target')">
                    {{ $t('config-manager::operate-config::目标配置') }}
                  </a>
                </div>
              </div>
            </div>
          </template>
        </reportChart>
      </el-col>
    </el-row>
    <el-card>
      <div class="search-wrap">
        <div>
          <el-cascader
            style="width: 250px"
            v-model="team"
            :options="teams"
            clearable
            :placeholder="$t('config-manager::operate-config::请选择团队')"
            :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
            @change="freshData"
            :appendToBody="false"
          ></el-cascader>
          <!-- <el-select v-model="params.optimist" placeholder="请选择选择优化师">
            <el-option :label="item.name" :value="item.id" v-for="item in camps" :key="item.id"></el-option>
          </el-select> -->
          <el-date-picker
            v-model="params.dtMonth"
            type="month"
            :clearable="false"
            value-format="yyyy-MM"
            format="yyyy-MM"
            class="ml-16"
            @change="freshData"
            :appendToBody="false"
          ></el-date-picker>
        </div>
        <el-button type="primary" @click="$router.push('/merits-board-detail')">
          {{ $t('merits-board::查看详情') }}
        </el-button>
      </div>
    </el-card>
    <el-row :gutter="18" class="row-flex">
      <el-col :lg="8" :md="24" :sm="24" :xl="8" class="col-flex">
        <reportTable :config="teamConfig" @change="changeTeamType" v-loading="loading.teamLoading">
          <div slot="other" v-if="drowText.length">
            <a v-for="(item, index) in drowText" :key="item.id" @click="upTeam(index)">
              {{ item.name }}
              <span style="margin: 0 8px" v-if="index < drowText.length - 1">-</span>
            </a>
          </div>
          <el-table-column type="index" :label="$t('merits-board::排名')" width="70"></el-table-column>
          <el-table-column prop="name" :label="$t('merits-board::名称')" min-width="100px" showOverflowTooltip>
            <template slot-scope="{ row }">
              <span v-if="row.thirdLevelGroupId !== undefined">{{ row.name }}</span>
              <a @click="drowTeam(row)" v-else>{{ row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmv"
            :label="$t('merits-board::成交额') + '($)'"
            min-width="100px"
            showOverflowTooltip
            v-if="teamType === 1"
          ></el-table-column>
          <el-table-column
            prop="process"
            :label="$t('merits-board::目标达成') + '(%)'"
            min-width="100px"
            showOverflowTooltip
            v-else
          ></el-table-column>
        </reportTable>
      </el-col>
      <el-col :lg="8" :md="24" :sm="24" :xl="8" class="col-flex">
        <reportTable :config="campConfig" @change="changeCampType" v-loading="loading.campLoading">
          <div slot="other" v-if="drowText.length" style="height: 18px"></div>
          <el-table-column type="index" :label="$t('merits-board::排名')" width="70"></el-table-column>
          <el-table-column
            prop="name"
            :label="$t('merits-board::名称')"
            min-width="100px"
            showOverflowTooltip
          ></el-table-column>
          <el-table-column
            prop="gmv"
            :label="$t('merits-board::成交额') + '($)'"
            min-width="100px"
            showOverflowTooltip
            v-if="campType === 1"
          ></el-table-column>
          <el-table-column
            prop="process"
            :label="$t('merits-board::目标达成') + '(%)'"
            min-width="100px"
            showOverflowTooltip
            v-else
          ></el-table-column>
        </reportTable>
      </el-col>
      <el-col :lg="8" :md="24" :sm="24" :xl="8" class="col-flex">
        <reportTable :config="shopConfig" v-loading="loading.shopLoading">
          <div slot="other" v-if="drowText.length" style="height: 18px"></div>
          <el-table-column type="index" :label="$t('merits-board::排名')" width="70"></el-table-column>
          <el-table-column
            prop="name"
            :label="$t('merits-board::名称')"
            min-width="100px"
            showOverflowTooltip
          ></el-table-column>
          <el-table-column
            prop="gmv"
            :label="$t('merits-board::成交额') + '($)'"
            min-width="100px"
            showOverflowTooltip
          ></el-table-column>
        </reportTable>
      </el-col>
    </el-row>
    <div>
      <reportCard :config="dataConfig" @change="changeData" v-loading="loading.dataLoading">
        <template #search>
          <div class="mt-16">
            <el-select
              v-model="dataParams.type"
              :placeholder="$t('merits-board::typeHolder')"
              class="mr-16"
              @change="getDataConfig"
            >
              <el-option
                :label="$t('merits-board::分时趋势')"
                :value="1"
                :disabled="dataParams.measure.some(i => ['ad_total_fee', 'roi'].includes(i))"
              ></el-option>
              <el-option :label="$t('merits-board::分日趋势')" :value="2"></el-option>
              <el-option :label="$t('merits-board::分月趋势')" :value="3"></el-option>
            </el-select>
            <el-select
              v-model="dataParams.measure"
              :placeholder="$t('merits-board::请选择标签')"
              class="mr-16"
              multiple
              :multiple-limit="2"
              @change="getDataConfig"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in tags"
                :key="item.value"
                :disabled="(item.value == 'ad_total_fee' || item.value == 'roi') && dataParams.type === 1"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="dataParams.dt"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              @change="getDataConfig"
            ></el-date-picker>
          </div>
        </template>
      </reportCard>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { formatNumberMix } from '@/utils'
import reportCard from '@/components/data-analysis/report'
import reportChart from '@/components/data-analysis/reportChart'
import reportTable from '@/components/data-analysis/table'
import defaultData from '@/components/common/default-data'
import setConfig from './setConfig'
import {
  getPerforTarget,
  getPerforTeamRank,
  getPerforOptimistRank,
  getPerforBrandRank,
  getPerforSaleTrend,
} from '@/server/etl'
import { teamList } from '@/server/team-manage'
export default {
  mixins: [setConfig],
  components: { reportCard, reportChart, reportTable, defaultData },
  data() {
    return {
      teamTarget: {},
      personalTarget: {},
      perforTarget: {},
      teamConfig: {},
      campConfig: {},
      shopConfig: {},
      dataConfig: {},
      team: [],
      params: {
        // optimist: '',
        dtMonth: moment().format('YYYY-MM'),
        // dtMonth: '2021-11',
        orgUnitId: this.$store.state.user.merchantId,
      },
      dataParams: {
        type: 2,
        measure: ['grand_total_usd', 'order_num'],
        dt: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      },
      teams: [],
      tags: [
        { label: this.$t('merits-board::成交额'), value: 'grand_total_usd' },
        { label: this.$t('merits-board::订单量'), value: 'order_num' },
        { label: this.$t('merits-board::营销费用'), value: 'ad_total_fee' },
        { label: this.$t('merits-board::ROI'), value: 'roi' },
        { label: this.$t('merits-board::销量'), value: 'sale' },
      ],
      shops: [],
      camps: [],
      loading: {
        cardLoading: false,
        teamLoading: false,
        campLoading: false,
        shopLoading: false,
        dataLoading: false,
      },
      teamType: 1,
      campType: 1,
      doubleShaft: '2',
      drowText: [],
    }
  },
  computed: {
    teamObj() {
      let obj = {}
      if (this.team) {
        if (this.team[0]) obj['sale_group_id'] = this.team[0]
        if (this.team[1]) obj['second_level_group_id'] = this.team[1]
        if (this.team[2]) obj['third_level_group_id'] = this.team[2]
      }
      return obj
    },
  },
  mounted() {
    this.getTeam()
    this.teamTarget = this.setTargetOption({ value: 0 })
    this.personalTarget = this.setTargetOption({ value: 0, color: '#FF9836', emptyColor: '#FCF6ED' })
    this.init()
  },
  methods: {
    formatNumberMix,
    drowTeam(row) {
      if (row.thirdLevelGroupId) {
        return
      } else if (row.secondLevelGroupId) {
        this.drowText = [...this.drowText, row]
      } else if (row.saleGroupId) {
        this.drowText = [row]
      }
      this.getTeamConfig()
    },
    upTeam(index) {
      this.drowText = this.drowText.slice(0, index)
      this.getTeamConfig()
    },
    changeTeamType(type) {
      this.teamType = type
      this.getTeamConfig()
    },
    changeCampType(type) {
      this.campType = type
      this.getCampConfig()
    },
    changeData(type) {
      this.doubleShaft = type
      this.getDataConfig()
    },
    init() {
      this.getCardOption()
      this.getTeamConfig()
      this.getCampConfig()
      this.getShopConfig()
      this.getDataConfig()
    },
    freshData() {
      this.drowText = []
      this.getTeamConfig()
      this.getCampConfig()
      this.getShopConfig()
      this.getDataConfig()
    },
    async getCardOption() {
      this.loading.cardLoading = true
      const { data } = await getPerforTarget({
        userId: this.$store.state.user.userId,
        orgUnitId: this.$store.state.user.merchantId,
        // dtMonth: '2021-11'
        dtMonth: moment().format('YYYY-MM'),
      })
      this.loading.cardLoading = false
      if (data.code === this.$code) {
        const target = (data.data.datas.length && data.data.datas[0]) || {}
        this.perforTarget = target
        this.teamTarget = this.setTargetOption({ value: target.teamProcess })
        this.personalTarget = this.setTargetOption({ value: target.process, color: '#FF9836', emptyColor: '#FCF6ED' })
      }
    },
    async getTeamConfig() {
      this.loading.teamLoading = true
      let drill = this.drowText.length ? this.$deepClone(this.drowText[this.drowText.length - 1]) : {}
      delete drill.gmv
      delete drill.name
      delete drill.orgUnitId
      delete drill.process
      const { data } = await getPerforTeamRank({
        ...this.params,
        type: this.teamType,
        ...this.teamObj,
        ...drill,
      })
      this.loading.teamLoading = false
      if (data.code === this.$code) {
        this.teamConfig = this.setTeamConfig(data.data.datas, this.teamType)
      }
    },
    async getCampConfig() {
      this.loading.campLoading = true
      const { data } = await getPerforOptimistRank({
        ...this.params,
        type: this.campType,
        ...this.teamObj,
      })
      this.loading.campLoading = false
      if (data.code === this.$code) {
        this.campConfig = this.setCampConfig(data.data.datas, this.campType)
      }
    },
    async getShopConfig() {
      this.loading.shopLoading = true
      const { data } = await getPerforBrandRank({
        ...this.params,
        ...this.teamObj,
      })
      this.loading.shopLoading = false
      if (data.code === this.$code) {
        this.shopConfig = this.setShopConfig(data.data.datas)
      }
    },
    async getDataConfig() {
      this.loading.dataLoading = true
      const { data } = await getPerforSaleTrend({
        startDate: this.dataParams.dt[0],
        endDate: this.dataParams.dt[1],
        measure1: (this.dataParams.measure && this.dataParams.measure.length && this.dataParams.measure[0]) || '',
        measure2: (this.dataParams.measure && this.dataParams.measure.length > 1 && this.dataParams.measure[1]) || '',
        type: this.dataParams.type,
        orgUnitId: this.$store.state.user.merchantId,
        ...this.teamObj,
      })
      this.loading.dataLoading = false
      if (data.code === this.$code) {
        this.dataConfig = this.setDataConfig(data.data.datas, this.doubleShaft, this.dataParams.measure)
      }
    },
    async getTeam() {
      const { data } = await teamList({
        pageNum: 1,
        pageSize: 10000,
      })
      if (data.code === this.$code) {
        this.teams = (data.data && this.setTreeData(data.data.items)) || []
      }
    },
    setTreeData(arr) {
      const fn = arr => {
        return arr.map(item => {
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          }
          return item
        })
      }
      return fn(arr)
    },
  },
}
</script>

<style scoped lang="scss">
.info-wrap {
  display: flex;
  flex-direction: column;
  width: 275px;
  padding: 20px 0 20px 20px;
  .info-title {
    color: #8a909d;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .info-number {
    font-size: 28px;
    font-weight: bold;
    color: #010517;
  }
  .info-next {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #ebeaea;
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #8a909d;
    font-size: 14px;
    .info-left {
      display: flex;
      align-items: center;
      .ring {
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 2px solid #ffcc5e;
        border-radius: 50%;
        margin-right: 12px;
      }
    }
  }
}
.search-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row-flex {
  // display: flex;
  // flex-wrap: wrap;
  // .col-flex {
  //   min-height: 100%;
  // }
}
</style>
